import { Component, OnInit, OnDestroy } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { Location } from '@angular/common';
import { TamasAlunoService } from '../tamas-aluno.service';
import { AlertaSimplesDialog } from '../alerta-simples';
import { AlertaConfirmDialog } from '../alerta-confirm';
import { MatDialog, MatDialogRef, MAT_DATE_LOCALE, MAT_DIALOG_DATA } from '@angular/material';
import * as moment from 'moment';
declare function RenderizarEvolucaoPeso(peso, massamagra, massagorda, periodo): any;

@Component({
  selector: 'app-me-evolucao',
  templateUrl: './me-evolucao.component.html',
  styleUrls: ['./me-evolucao.component.css']
})
export class MeEvolucaoComponent implements OnInit {
  existeAv: boolean = false;
  hideCL: boolean = false;
  arrAvaliacoes: any[] = [];
  idsAvaliacoes: any;
  masculino: boolean = true;

  dadosCirc: any = '';
  dadosDobra: any = '';
  dadosComp: any = '';
  dadosCooper: any = '';
  dadosRM: any = '';
  dadosAV: any = '';
  dadosGET: any = '';
  arrAvSelec: any[] = [];

  columnsCooper = ['Avaliação', 'Distância', 'Velocidade Média', 'Velocidade Limiar', 'Volume Oxigênio Máx'];
  columnsRM = ['Avaliação', 'Exercício', 'Carga Total', 'Repetições', 'Resultado 1 RM'];
  columnsGET = ['Avaliação', 'Equação', 'Taxa Metabólica Basal', 'Fator Atividade', 'Gasto Energético Total'];
  displayedColumns = ['Avaliação', 'Ombro', 'Tórax', 'Abdomem', 'Quadril', 'Braço D Rl','Braço D Ct', 'Braço E Rl', 'Braço E Ct','Antebraço D', 'Antebraço E', 'Coxa D', 'Coxa E', 'Panturrilha D', 'Panturrilha E' ];
  displayedColumns2 = [{key: 'Parte', header: 'Parte'}];
  displayedColumns3= [{key: 'Parte', header: 'Parte'}];
  displayedColumnsKeys: string[];
  displayedColumnsKeys3: string[];
  //graph things
  view: any[] = [992, 300];
  // options for the chart
  showXAxis = true;
  showYAxis = true;
  gradient = true;
  showLegend = false;
  // options
  legend: boolean = true;
  legendTitle: any = '';
  showLabels: boolean = true;
  animations: boolean = true;
  xAxis: boolean = true;
  yAxis: boolean = true;
  showYAxisLabel: boolean = true;
  showXAxisLabel: boolean = true;
  xAxisLabel: string = 'Composição';
  xAxisLabel2: string = 'Avaliações';
  yAxisLabel: string = 'Valor em Kg';
  yAxisLabel3: string = 'Valor em MM';
  timeline: boolean = true;
  dataplano: any = '';
  datahj: any = '';
  contadorDP: any = 0;
  // customColors = (value) => {
  //   console.log(value);
  //   return "#ff0000";
  // }
  // customColors = [
  //   { 
  //     name: '(6) 10/02/2020',
  //     value: '#ffd400'
  //   }
  // ];

  // colorScheme = {
  //   domain: ['#2597fb', '#65ebfd', '#99fdd0', '#3f51b5', '#647c8a', '#a8385d', '#aae3f5']
  // };
  // colorSchemePeso = {
  //   domain: ['#ff4f46', '#2ade89', '#ffd400']
  // };
  colorSchemePeso = {
    domain: ['#58dc65', '#de5353', '#eee244']
  };
  colorScheme = {
    domain: ['#DE5353', '#3400F2', '#999999', '#00F2E2', '#F27D00', '#EE4488', '#EEE244', '#04670E', '#58DC65']
  };
  colorSchemeMassa = {
    domain: ['#2597fb', '#65ebfd', '#99fdd0', '#3f51b5', '#647c8a', '#a8385d', '#aae3f5']
  }
  //pie
  //showLabels = true;
  // data goes here
  public single = [];
  public multiLine = [];
  public multiBar = [];
  public multiDobras = [];
  public grAdereDia = [];
  public aproveitamento = [];
  arrComp: any[] = [];
  arrAv: any[] = [];
  startView: string = "multi-year"
  arrCirc: any[] = [];
  arrDobras: any[] = [];
  tabelaCircu: any[] = [];
  tabelaCooper: any[] = [];
  tabelaRM: any[] = [];
  tabelaGET: any[] = [];
  tabelaDobras: any[] = [];
  dataEvPeso: any[] = [];
  dataEvMassaM: any[] = [];
  dataEvMassaG: any[] = [];
  dataEvPeriodo: any[] = [];
  constructor(private route: ActivatedRoute, private _location: Location, public router: Router, public tmaService: TamasAlunoService, public dialog: MatDialog) { }

  ngOnInit() {
    //this.hideCL = true;
    //this.existeTreino = true;
    this.tmaService.eventoFS(true);
    this.idsAvaliacoes = this.route.snapshot.paramMap.get('idsavaliacoes');
    this.compararAval();

    //this.loadScript('../../assets/js/grafico-apx.js');
    //this.carregarAvaliacao();
    //this.tmaService.hcPremium = true;
    // var numeroPerc = this.dadosComp.MassaGorduraPercentual / 100;
    // setProgress(numeroPerc, this.masculino);

    //setProgress(0.25, this.masculino);
  }

  ngOnDestroy() {
    this.tmaService.eventoFS(false);
  }


  public loadScript(url: string) {
    const body = <HTMLDivElement> document.body;
    const script = document.createElement('script');
    script.innerHTML = '';
    script.type = 'text/javascript';
    script.src = url;
    script.async = false;
    script.defer = true;
    body.appendChild(script);
  }

  goFichaTreino(idTreino: any): void {
    this.router.navigate(['me/fichatreino/' + idTreino]);
  }

  compararAval(): void {
    //tratar o array
    this.arrAvSelec = [];
    var allAval = this.idsAvaliacoes.split('-');
    console.log(allAval);
    allAval.forEach(element => {
      this.arrAvSelec.push({ idavaliacao: element });
    });

 
    if (this.arrAvSelec.length < 2) {
      const avisoSele = this.dialog.open(AlertaSimplesDialog, {
        // width: '250px',
        disableClose: true,
        data: { textoAlerta: "Você deve escolher pelo menos 2 avaliações para gerar um relatório" }
      });

    }
    else {
      var meuArray = JSON.stringify(this.arrAvSelec);

      let customParams = {
        //lista: localStorage.getItem('turboCart'),
        email: this.tmaService.hcEmail,
        senha: this.tmaService.hcSenha,
        listaAvaliacoes: meuArray
      };


      this.hideCL = false;
      this.tmaService.compararAvaliacoes(customParams)
        .subscribe((qDados) => {
          console.log(qDados);
          this.hideCL = true;
          if (qDados['res'] == 'ok') {
            this.arrComp = qDados['dadosComp'];

           
            this.arrCirc = qDados['dadosCirc'];
            this.arrDobras = qDados['dadosDobras'];
            this.dadosAV =  qDados['dadosAv'];
            this.dadosCooper = qDados['dadosCooper'];
            this.dadosRM = qDados['dadosRM'];
            this.dadosGET = qDados['dadosGET'];
            this.tabelaDobras = qDados['dadosDobras2'];
            this.tabelaCircu = qDados['dadosCircunferencias2'];
            if(this.dadosAV != null){
              this.dadosAV.forEach(element => {
                element.DataAvaliacao =  moment(element.DataAvaliacao).format('DD/MM/YYYY');
              });
            }


            this.arrComp.forEach((item, idx) => {
              this.dataEvPeso.push(item.MassaCorporal);
              this.dataEvMassaM.push(item.MassaLivreGorduraKg);
              this.dataEvMassaG.push(item.MassaGorduraKg);
              var tagAV = "(" + (idx + 1) + ") " + this.dadosAV.find(x => x.Id == item.IdAvaliacao).DataAvaliacao;
              this.dataEvPeriodo.push(tagAV);
            });
            setTimeout(() => {
              RenderizarEvolucaoPeso(this.dataEvPeso, this.dataEvMassaM, this.dataEvMassaG, this.dataEvPeriodo);  
            }, 0);
            
            console.log("meu array de peso");
            console.log(this.dataEvPeso);

            this.renderGrafic();
          }
          else {
            //erro
          }
        })
    }

  }

  renderGrafic(): void {
    var avComp = [];
    var av_massaAV = [];

    var av_massaC = [];
    var av_massaG = [];
    var av_massaGp = [];
    var av_massaM = [];
    var av_massaMp = [];

    var db_Subescapular = [];
    var db_Triceps = [];
    var db_Peitoral = [];
    var db_Biceps = [];
    var db_AxilarMedia = [];
    var db_Suprailiaca = [];
    var db_Adbominal = [];
    var db_CoxaMedial = [];
    var db_Perna = [];

    this.arrDobras.forEach((item, idx) => {
      var nomeAv = "(" + (idx + 1) + ") " + this.dadosAV.find(x => x.Id == item.IdAvaliacao).DataAvaliacao;
      
      db_Subescapular.push({ name: nomeAv, value: item.DbSubescapular });
      db_Triceps.push({ name: nomeAv, value: item.DbTriceps });
      db_Peitoral.push({ name: nomeAv, value: item.DbPeitoral });
      db_Biceps.push({ name: nomeAv, value: item.DbBiceps });
      db_AxilarMedia.push({ name: nomeAv, value: item.DbAxilarMedia });
      db_Suprailiaca.push({ name: nomeAv, value: item.DbSuprailiaca });
      db_Adbominal.push({ name: nomeAv, value: item.DbAdbominal });
      db_CoxaMedial.push({ name: nomeAv, value: item.DbCoxaMedial });
      db_Perna.push({ name: nomeAv, value: item.DbPerna });
    });


    this.arrComp.forEach((item, idx) => {
      // avComp.push({name: item.dia, value: item.qtdDone });
      //var nomeAv = this.arrAvaliacoes.find(x => x.idavaliacao == item.IdAvaliacao).titulo + " (" + item.IdAvaliacao + ")";
      //var nomeAv = "(" + item.IdAvaliacao + ") " + this.arrAvaliacoes.find(x => x.idavaliacao == item.IdAvaliacao).data;
      //var nomeAv = "(" + item.IdAvaliacao + ") " + this.arrAvaliacoes.find(x => x.idavaliacao == item.IdAvaliacao).titulo;
      //var nomeAv = "(" + (idx + 1) + ") " + this.dadosAV.find(x => x.Id == item.IdAvaliacao).Titulo;
      var nomeAv = "(" + (idx + 1) + ") " + this.dadosAV.find(x => x.Id == item.IdAvaliacao).DataAvaliacao;
      av_massaC.push({ name: nomeAv, value: item.MassaCorporal });
      av_massaG.push({ name: nomeAv, value: item.MassaGorduraKg });
      av_massaGp.push({ name: nomeAv, value: item.MassaGorduraPercentual });
      av_massaM.push({ name: nomeAv, value: item.MassaLivreGorduraKg });
      av_massaMp.push({ name: nomeAv, value: item.MassaLivreGorduraPercentual });

      //agrupar por item da composição - peso, massa magra e gordura
      av_massaAV.push({ name: nomeAv, series: [{ name: 'Peso' , value: item.MassaCorporal},{ name: 'Massa Magra', value: item.MassaLivreGorduraKg }, { name: 'Gordura', value: item.MassaGorduraKg } ] });

      var numQ = idx + 1;
      this.displayedColumns2.push({key: 'Resultado' + numQ,  header: nomeAv});
      this.displayedColumns3.push({key: 'Resultado' + numQ,  header: nomeAv});
    });

    this.displayedColumnsKeys = this.displayedColumns2.map(col => col.key);
    this.displayedColumnsKeys3 = this.displayedColumns3.map(col => col.key);
    this.multiDobras = [{ name: 'Subescapular', series: db_Subescapular }, { name: 'Tríceps', series: db_Triceps }, { name: 'Peitoral', series: db_Peitoral }, { name: 'Bíceps', series: db_Biceps }, { name: 'Axila', series: db_AxilarMedia },
    { name: 'Supra Ilíaca', series: db_Suprailiaca }, { name: 'Abdominal', series: db_Adbominal }, { name: 'Coxa', series: db_CoxaMedial }, { name: 'Panturrilha', series: db_Perna }];

    this.multiLine = [{ name: "Peso", series: av_massaC }, { name: "Magra", series: av_massaM }, { name: "Gordura", series: av_massaG }];
    this.multiBar = av_massaAV;


    this.single = av_massaMp;

    //tabela circ e dobras
    // var arrTcirc = [];
    // this.arrCirc.forEach(item => {
    //   //var nomeAv = this.dadosAV.find(x => x.Id == item.IdAvaliacao).Titulo;
    //   var nomeAv = this.dadosAV.find(x => x.Id == item.IdAvaliacao).DataAvaliacao;
    //   // arrTcirc.push({
    //   //   nome: nomeAv, Ombro: item.MedOmbro, Tronco: item.MedTronco, Abdomem: item.MedAbdomem
    //   //  })

    //   arrTcirc.push({
    //     Avaliação: nomeAv, Ombro: item.MedOmbro, Tórax: item.MedTronco, Abdomem: item.MedAbdomem, Quadril: item.MedQuadril, 'Braço D Rl': item.MedBracoDRelax,
    //     'Braço D Ct': item.MedBracoDContra, 'Braço E Rl': item.MedBracoERelax, 'Braço E Ct': item.MedBracoEContra, 'Antebraço D': item.MedAntBracoD,
    //     'Antebraço E': item.MedAntBracoE, 'Coxa D': item.MedCoxaD, 'Coxa E': item.MedCoxaE, 'Panturrilha D': item.MedPernaD, 'Panturrilha E': item.MedPernaE
    //   })

    // });
    // this.tabelaCircu = arrTcirc;
    // console.log(this.tabelaCircu);

    //tabela cooper
    var arrCooper = [];
    this.dadosCooper.forEach(item => {
      var nomeAv = this.dadosAV.find(x => x.Id == item.IdAvaliacao).Titulo + " - " + this.dadosAV.find(x => x.Id == item.IdAvaliacao).DataAvaliacao;
      arrCooper.push({
        Avaliação: nomeAv, 'Distância': item.Distancia, 'Velocidade Média': item.VelocidadeMedia, 'Velocidade Limiar': item.VelocidadeLimiar, 'Volume Oxigênio Máx': item.VolumeOx
      })
    });
    this.tabelaCooper = arrCooper;


    //tabela rm
    var arrRM = [];
    this.dadosRM.forEach(item => {
      var nomeAv = this.dadosAV.find(x => x.Id == item.IdAvaliacao).Titulo + " - " + this.dadosAV.find(x => x.Id == item.IdAvaliacao).DataAvaliacao;
      arrRM.push({
        Avaliação: nomeAv, 'Exercício': item.Exercicio, 'Carga Total': item.PesoLevantado, 'Repetições': item.NumeroRepeticoes, 'Resultado 1 RM': item.ResultadoRM
      })
    });
    this.tabelaRM = arrRM;

    //tabela get
    var arrGET = [];
    this.dadosGET.forEach(item => {
      var nomeAv = this.dadosAV.find(x => x.Id == item.IdAvaliacao).Titulo + " - " + this.dadosAV.find(x => x.Id == item.IdAvaliacao).DataAvaliacao;
      arrGET.push({
        Avaliação: nomeAv, 'Exercício': item.Exercicio, 'Equação': item.Equacao, 'Taxa Metabólica Basal': item.TMB, 'Fator Atividade': item.FA, 'Gasto Energético Total': item.ResultadoGET
      })
    });
    this.tabelaGET = arrGET;
  }


  renderizarGrafico(): void {

    this.single = [{
      "name": "Peso Total ",
      "value": this.dadosComp.MassaCorporal
    },
    {
      "name": "Massa de Gordura",
      "value": this.dadosComp.MassaGorduraKg
    },
    {
      "name": "Massa Magra",
      "value": this.dadosComp.MassaLivreGorduraKg
    },
    ];

  }

  onSelect(data): void {
    console.log('Item clicked', JSON.parse(JSON.stringify(data)));
  }

  onActivate(data): void {
    console.log('Activate', JSON.parse(JSON.stringify(data)));
    //this.showYAxisLabel = false;
  }

  onDeactivate(data): void {
    //this.showYAxisLabel = true;
    console.log('Deactivate', JSON.parse(JSON.stringify(data)));
  }

  changeCk(idAval: any, qDone: any) {
    this.arrAvaliacoes.find(x => x.Id == idAval).ck = qDone;
    console.log(this.arrAvaliacoes);
  }


 
  goDetail(idAvaliacao: any): void {
    this.router.navigate(['/me/avaliacao/' + idAvaliacao]);
  }

  voltar(): void {
    // this.router.navigate(['/home']);
    this.router.navigate(['/me/avaliacoes']);
  }
}
